module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Fisibach-2bce34d0af0bc540622ae776d1f8d0c7.svg";